module.exports = __webpack_public_path__ + "img/product-details-5.a604b0e7.svg";